import { AppConfig } from 'data/terra/AppConfig';
import { Environment } from 'data/terra/Environment';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import Terra from 'services/apis/terra/Terra';
import { RootState } from 'store/reducer';
import {
  FetchResourceAction,
  fetchResourceDelegate,
  Resource,
  ResourceActionTypes,
} from 'v2/store/common/Resource';
import { ProjectDetailState } from '../state';
import { selectEnv } from './SelectEnv';
import { selectAppConfig } from './SelectAppConfig';

const ActionTypes: ResourceActionTypes = {
  requestFetching: 'project/appConfigs/fetch',
  fetchSuccess: 'project/appConfigs/fetchSuccess',
  fetchFailure: 'project/appConfigs/fetchFailure',
};

export type FetchAppConfigsAction = FetchResourceAction<AppConfig[]>;

export const fetchAppConfigsForCurrentAppVersion = (): ThunkAction<
  void,
  RootState,
  unknown,
  Action<string>
> => async (dispatch, getState) => {
  const selectedApp = getState().projectDetail.selectedApp;
  const selectedAppVersion = getState().projectDetail.selectedAppVersion;
  const environments = getState().common.environments;

  if (!selectedApp || !selectedAppVersion) return;

  dispatch({
    type: ActionTypes.requestFetching,
  } as FetchAppConfigsAction);

  const result = await Terra.appConfig.fetchAppConfigs(
    selectedApp.id,
    selectedAppVersion.id
  );

  if (result.isSuccess()) {
    const appConfigs = result.get()!.data;
    dispatch({
      type: ActionTypes.fetchSuccess,
      data: appConfigs,
    } as FetchAppConfigsAction);

    const activeConfig = appConfigs.find((c: AppConfig) => c.isActive);
    if (activeConfig) {
      dispatch(selectAppConfig(activeConfig));
      const activeEnv = environments.find(
        (e: Environment) => e.id === activeConfig.env.id
      );
      if (activeEnv) {
        dispatch(selectEnv(activeEnv));
      }
    }
  } else {
    dispatch({
      type: ActionTypes.fetchFailure,
      error: result.exception(),
    } as FetchAppConfigsAction);
  }
};

export const fetchAppConfigsDelegate = fetchResourceDelegate<
  ProjectDetailState,
  AppConfig[]
>(
  ActionTypes,
  (
    rootState: ProjectDetailState,
    reduce: (state: Resource<AppConfig[]>) => Resource<AppConfig[]>
  ) => {
    return {
      ...rootState,
      appConfigs: reduce(rootState.appConfigs),
    };
  }
);
